
import React, { Suspense, useState, useEffect } from "react";
import WizardServices from "./WizardServices";
import ContactSummary from "./contactSummary";
import cachingMechanisum from "../Common/cachingMechanisum";

export default function ContactWizardStatus(MainWizard: any) {

    const [save, setsave] = useState(false);
    const [unfield, setunfield] = useState(false);
    const [contactInfo, initContactInfo] = useState<any>([]);
    const [PayeeStatusList, initPayeeStatusList] = useState<any>([]);
    const [StatementCategoryList, initStatementCategoryList] = useState<any>([]);

    useEffect(() => {
        console.log(MainWizard.data.code)

        if (MainWizard.data.code) {
            apiCall();
        }

        const StatementCategory = "StatementCategory"

        var lookUpTypeList = cachingMechanisum.getCachingStorage("lookUpType")
        const StatementCategoryListing = lookUpTypeList?.filter((item: any) =>
            item.lookUpType.toLowerCase().includes(StatementCategory.toLowerCase())
        );
        initStatementCategoryList(StatementCategoryListing)
        const PayeeStatus = "StatusPayee"
        const PayeeStatusListing = lookUpTypeList?.filter((item: any) =>
            item.lookUpType.toLowerCase().includes(PayeeStatus.toLowerCase())
        );
        initPayeeStatusList(PayeeStatusListing)
        //console.log( PayeeStatusListing)
        //console.log( StatementCategoryListing)

    }, []);

    const apiCall = () => {
        WizardServices.contactInfo(MainWizard.data.code).then((res) => {
            initContactInfo(res)
        })
    }
    const saveCreator = () => {
        console.log(contactInfo)
        WizardServices.kontactSave(contactInfo, {}).then((res) => {
            setsave(true);
            apiCall();
        });
        setTimeout(function () {
            setsave(false);
        }, 3000);
    }

    const clearSForm = () => {
        initContactInfo([])
    }

    return (
        <>
            <div className="ws-12 ">
                <div className="w-65 ps">
                    <div className="box">
                        <div className="box-header">
                            <h1>Statuses</h1>
                        </div>
                        <div className="box-content allowVscroll" style={{ height: "545px", marginLeft: "5%;" }}>
                            <div className="ws-12" ng-show="true">

                                <div className="form-format">
                                    <label className="control-label"> Statement Category </label>

                                    <div className="label-entries">
                                        <select id="contactInfo.statementStatus" name="statementStatus" ng-model="contactInfo.statementCategory" value={contactInfo.statementCategory}>
                                            <option value=""  >Choose Statement Category</option>

                                            {
                                                StatementCategoryList?.map((values: any) => {
                                                    return (
                                                        <option value={values.key} label={values.value}>{values.value}</option>
                                                    )
                                                })
                                            }
                                        </select>

                                    </div>
                                </div>

                                <div className="form-format">
                                    <label className="control-label">Payee Status </label>

                                    <div className="label-entries">
                                        <select id="contactInfo.payeeStatus" name="payeeStatus" ng-model="contactInfo.payeeStatus" value={contactInfo.payeeStatus}>
                                            <option value="">Choose Payee Status</option>
                                            {
                                                PayeeStatusList?.map((values: any) => {
                                                    return (
                                                        <option value={values.key} label={values.value}>{values.value}</option>
                                                    )
                                                })
                                            }
                                        </select>

                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="box-footer">
                            <div className="pull-right">
                                <button className="icon-btn edit" onClick={() => saveCreator()}> <i className="icon-save"></i> Save </button>
                                <button className="btn-pink" onClick={() => clearSForm()}>  <i className="icon-reload"></i> Reset </button>
                            </div>

                        </div>
                    </div>
                </div>
                <div className="w-35 ps ">
                    <ContactSummary data={contactInfo} />
                </div>
            </div>

        </>
    )

}